import { Component, Input } from '@angular/core';

export type StatusIconVariant = 'default' | 'error' | 'warning' | 'success';

@Component({
  selector: 'app-status-variant-icon',
  templateUrl: './status-variant-icon.component.html',
  styleUrls: ['./status-variant-icon.component.scss']
})
export class StatusVariantIconComponent {
  @Input() variant: StatusIconVariant = 'default';
  @Input() iconClass = 'fa-solid fa-exclamation-circle';
  @Input() tooltipTitle = '';
  @Input() tooltipPosition = 'right';
  @Input() tooltipClass = 'tooltipwidth300';
  @Input() customColor?: string;
  @Input() customClass = '';

  public get iconColor(): string | null {
    if (this.customColor) {
      return this.customColor;
    }

    switch (this.variant) {
      case 'error':
        return 'rgba(211, 19, 36, 1)';
      case 'warning':
        return '#ffc000';
      case 'success':
        return 'rgba(58, 182, 62, 1)';
      default:
        return null;
    }
  }
}
